import React from "react";
import { useStores } from "stores/storeInitializer";
import { ActiveView } from "stores/store";

export const useSessionDetails = (id?: string, tenantId?: string) => {
    const { store } = useStores();

    // React.useEffect(() => {
    //     if (!store.tenantLogo) {
    //         Util.tenantsLogoList({ ID: tenantId }, { format: 'blob' }).then((res) => {
    //             const reader = new FileReader();
    //             reader.readAsDataURL(res); // Converts the blob to Base64 string
    //             reader.onloadend = () => {
    //                 const base64data = reader.result;
    //                 store.setTenantLogo(base64data as string);
    //             }
    //         }).catch((e) => {
    //             console.error("Error while loading tenant logo", e)
    //         })
    //     }
    // }, [])

    const getTransactionDetails = React.useCallback(async () => {
        if (!store.token && store.token?.length !== 6) {
            store.setActiveView(ActiveView.Otp);
        }
        if (id && tenantId && store.deviceId) {
            await store.getTransactionsOtp(tenantId, id, { token: store.token || "", deviceID: store.deviceId }).then(() => {
                store.setActiveView(ActiveView.Details);
            }).catch((e) => {
                switch (e?.response?.status) {
                    //@ts-ignore
                    case 401:
                    case 403:
                        if (e.response?.data?.errorDetailedMessage?.time && !isNaN(e.response?.data?.errorDetailedMessage?.time)) {
                            store.setTimer(parseInt(e.response?.data?.errorDetailedMessage?.time));
                        }
                        store.setToken(null);
                        store.setActiveView(ActiveView.Otp);
                        break;
                    default:
                        console.error("Error while loading session details", e, e?.response?.status)
                        break;
                }
            })
                .finally(() => store.triggerActivity(false))
        } else {
            console.error("Error while loading session details", store.count, id, tenantId)
        }
    }, [id, store, tenantId])

    React.useEffect(() => {
        const interval = setInterval(() => {
            if (store.activeView === ActiveView.Details) {
                store.setCount(store.count + 1)
            }
        }, 15000);
        return () => clearInterval(interval);
    }, [store, store.count, store.activeView])

    React.useEffect(() => {
        getTransactionDetails()
    }, [getTransactionDetails, store.count])

}
